import {createReducer, omit} from 'helpers';

export const syncTokens = createReducer({}, {

  GOOGLE_CALENDAR_REMOVE_SYNC_TOKEN: (state, action) => omit(state, action.calendarId),

  GOOGLE_CALENDAR_DATA_RECEIVED: (state, action) => ({
    ...state,
    [action.calendarId]: action.nextSyncToken,
  }),

  APP_LAUNCH: () => ({}),
  GOOGLE_CALENDAR_FULL_READ: () => ({}),
  GOOGLE_CALENDAR_SIGNED_OUT: () => ({}),

});
